import { render, staticRenderFns } from "./AddressDetailsCard.vue?vue&type=template&id=12d6f605&"
import script from "./AddressDetailsCard.vue?vue&type=script&lang=js&"
export * from "./AddressDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports